$(document).ready(function() {

  /* Frontend */
  anchorGoToHash();
  formStyles();

  var swiper = new Swiper(".locationSwiper", {
    slidesPerView: "auto",
    spaceBetween: 16,
    watchOverflow: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
       1081: {
         slidesPerView: 2,
         centerInsufficientSlides: true,
       },
     }
  });

});
